import type { SrpViewModel } from '../../features/srp/SrpViewModel';

/**
 * Loads the full SRP view model for the current listing URL (same payload as progressive island).
 * Used to hydrate slim client navigations before mounting SearchProvider so layout matches static shell.
 */
export async function fetchSrpViewModelClient(pageUrl: string): Promise<SrpViewModel | null> {
  try {
    const res = await fetch(`/api/srp-state?url=${encodeURIComponent(pageUrl)}`, {
      method: 'GET',
      credentials: 'same-origin',
    });
    if (!res.ok) return null;
    return (await res.json()) as SrpViewModel;
  } catch {
    return null;
  }
}
